// src/lib/usePresenceAnalytics.ts
import { useEffect } from "react";
import { startHeartbeat, stopHeartbeat } from "./ga";

/** Heartbeat 15s pour "présence en direct" et meilleure durée d'engagement */
export default function usePresenceAnalytics() {
  useEffect(() => {
    startHeartbeat(15000);
    return () => stopHeartbeat();
  }, []);
}